import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('app.grouping_client'),
      path: 'configurations/clients/details',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: true,
      sc: [
        {
          name: i18n.t('grouping.companies'),
          path: 'configurations/grouping/companies',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('grouping.locations'),
          path: 'configurations/grouping/locations',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('grouping.agencies'),
          path: 'configurations/grouping/agencies',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('grouping.values'),
          path: 'configurations/grouping/values',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
      ]
    }
  ]
}
